"use strict";
import { isAllowedMaintenanceReturnTo } from "pages/AdjustPrice/maintenanceRoutes";
export function shouldWaitForLockedPairChainMode({
  hasLockedPairParams,
  hasRequestedChain,
  isStateRehydrated,
  isModeMismatch
}) {
  return hasLockedPairParams && hasRequestedChain && (!isStateRehydrated || isModeMismatch);
}
export function parseLockedPairSwapParams(search) {
  const params = new URLSearchParams(search);
  const targetPair = params.get("targetPair") ?? void 0;
  const inputCurrency = params.get("inputCurrency") ?? void 0;
  const outputCurrency = params.get("outputCurrency") ?? void 0;
  const value = params.get("value") ?? void 0;
  const rawReturnTo = params.get("returnTo");
  const returnTo = isAllowedMaintenanceReturnTo(rawReturnTo) ? rawReturnTo : void 0;
  const adjustmentStartedAt = Number(params.get("adjustmentStartedAt")) || void 0;
  const lockedPairParams = targetPair ? { targetPair, inputCurrency, outputCurrency, value } : void 0;
  const maintenanceParams = lockedPairParams && returnTo && adjustmentStartedAt ? { ...lockedPairParams, returnTo, adjustmentStartedAt } : void 0;
  return { lockedPairParams, maintenanceParams };
}
